import cdn from '@/utils/cdn';
import Vue from 'vue';

Vue.mixin({methods: { _cdn: cdn }})
